"use client";

export default function CookiePreferencesLink({
  className,
  label = "Cookie preferences",
}: {
  className?: string;
  label?: string;
}) {
  return (
    <button
      type="button"
      onClick={() => window.dispatchEvent(new CustomEvent("open-cookie-prefs"))}
      className={className}
    >
      {label}
    </button>
  );
}
